// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.menu-link a[data-v-81440b78] {\n\tcolor: hsl(0, 0%, 100%)\n}\n.align-icon[data-v-81440b78] {\n\tdisplay: inline-table;\n\tmargin-right: 10px;\n}\n.align-dropdown-icon[data-v-81440b78] {\n\tmargin-right: 10px;\n\tmargin-top: 2px\n}\n.horizontal-rule[data-v-81440b78] {\n\tmargin-top: 5px;\n\tmargin-bottom: 5px\n}\n.fixed[data-v-81440b78] { \n\tposition: fixed !important; \n\ttop: 0; \n\tleft: 0;\n}\n", ""]);
// Exports
module.exports = exports;
